@let legalData = metaData()['legalData'];
@let contactData = metaData()['contactData'];

<app-navbar  [id]="'c6f25ff1-3c1e-4bcb-a903-b834d6853517'" [componentId]="'c6f25ff1-3c1e-4bcb-a903-b834d6853517'"></app-navbar>

<div class="impressum-container">
  <h1 class="custom-title-medium">Impressum</h1>

  @if (legalData.useImprintTemplate) {
    <p class="custom-title-medium">Angaben gemäß § 5 TMG</p>
    <p class="custom-body-medium">
        {{legalData.businessName}}<br>
        {{contactData.name}}<br>
        {{legalData.businessStreet.value}}<br>
        {{legalData.businessCity.value}}<br>
    </p>

    @if (legalData.businessContactNames){
        <p class="custom-title-medium"><strong>Vertreten durch:</strong></p>
        <p class="custom-body-medium">
            @for(contactName of legalData.businessContactNames; let i = $index; track $index;) {    
                {{contactName.firstname}} {{contactName.surname}}<br>
            }
        </p>
    }

    <p class="custom-title-medium"><strong>Kontakt:</strong></p>
    <p class="custom-body-medium">
        Telefon: {{legalData.businessContactPhone.value}}<br>
        E-Mail: {{legalData.businessContactEmail.value}}<br>
    </p>

    @if(legalData.registrationNumber) {
      <p class="custom-title-medium"><strong>Registereintrag:</strong></p>
      <p class="custom-body-medium">
        Eintragung im Handelsregister.<br>
        @if(legalData.registrationNumber) {Registergericht: {{legalData.registrationNumber}}<br>}
        @if(legalData.registrationNumber) {Registernummer: {{legalData.registrationCity}}<br>}
      </p>
    }

    @if(legalData.vatId){
        <p class="custom-title-medium"><strong>Umsatzsteuer-ID:</strong></p>
        <p class="custom-body-medium">
          Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br>
          {{legalData.vatId}}
        </p>
    }

    @if (legalData.managerContentName.value) {
        <p class="custom-title-medium"><strong>Inhaltlich Verantwortlicher gemäß § 55 Abs. 2 RStV:</strong></p>
        <p class="custom-body-medium">
          @if(legalData.managerContentName.value){ {{legalData.managerContentName.value}}<br>}
          @if(legalData.managerContentStreet.value){ {{legalData.managerContentStreet.value}}<br>}
          @if(legalData.managerContentCity.value){ {{legalData.managerContentCity.value}}<br>}
          @if(legalData.managerContentPhone.value){Telefon: {{legalData.managerContentPhone.value}}<br>}
          @if(legalData.managerContentEmail.value){E-Mail: {{legalData.managerContentEmail.value}}<br>}
        </p>
    }

    <p class="custom-body-medium"> 
        Die Inhalte dieser Webseite wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernimmt der Betreiber {{legalData.businessName}} jedoch keine Gewähr. Als Anbieter der technischen Plattform und Dienstleister für das Design der Webseite übernimmt die Haertel & Vickers Digital Services GbR keine Haftung für die bereitgestellten Inhalte.
    </p>

    <p class="custom-title-medium"><strong>Streitschlichtung</strong></p>
    <p class="custom-body-medium">
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a
        href="https://ec.europa.eu/consumers/odr" target="_blank"
        rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>.<br>
        Unsere E-Mail-Adresse finden Sie oben im Impressum.
    </p>

    <p class="custom-body-medium">
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
        teilzunehmen.
    </p>
  }
  @else {
    <div [innerHTML]="legalData.customImprintContent"></div>
  }
</div>



